module.exports = __webpack_public_path__ + "images/cec93e87fd2e4047633dbaf24cec4b00.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/EstrangeloAntioch.woff2
// module id = 1152
// module chunks = 0